export const linuxLadsShellsLogo = require("./linux-lads_shells.png");
